export default "__VITE_ASSET__Shm0vY9c__"